import React from 'react';
import PropTypes from 'prop-types';
import MainMenuItem from './mainMenuItem';
const CabinetMenuItem = _ref => {
  let identifier = _ref.identifier,
    title = _ref.title,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'folder-open' : _ref$icon,
    path = _ref.path;
  return /*#__PURE__*/React.createElement(MainMenuItem, {
    className: "t-h-nav-".concat(identifier),
    key: "".concat(identifier, "Tab"),
    href: "/#".concat(path),
    glyph: icon,
    title: title
  });
};
CabinetMenuItem.propTypes = {
  identifier: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  path: PropTypes.string.isRequired
};
export default CabinetMenuItem;